APP.MODULES = window.APP.MODULES || {};
// --------------------------------------------------------------------------
// Used on the dashboard page
// --------------------------------------------------------------------------

APP.MODULES.dashboard = function() {
    'use strict';

    var dashboard = $('.js-dashboard', APP.Elements.wrapper);

    function updateDashboardHeight() {
        var columns = $('.js-dashboard-column', dashboard),
            banner = $('.js-dashboard-banner', dashboard),
            calculating = false,
            loading = true;

        function fixIE10() {
            if (bowser.msie && bowser.version <= 10) {
                columns.each(function(index, value) {
                    var column = $(value),
                        actionlinks = $('.js-actionlinks', column);

                    actionlinks.each(function(index, value) {
                        var actionlink = $(value);
                        actionlink.height(0).height(actionlink.parent().height());
                    });
                });
            }
        }

        function update() {
            var dashboardHeight = 0,
                bannerHeight = banner.length ? banner.outerHeight(true) : 0,
                fullHeight = win.data('height') - APP.Elements.header.data('height') - APP.Elements.footer.data('height') - bannerHeight,
                columnHeights = [];

            if (calculating) {
                return;
            }
            calculating = true;

            // Reset
            dashboard.addClass('reset');

            columns.each(function(index, value) {
                var column = $(value),
                    cardContainers = column.children('.js-card-container'),
                    columnHeight = 0;

                cardContainers.each(function(index, value) {
                    var container = $(value),
                        card = container.children('.js-card');

                    container.css('height', '');
                    columnHeight += card.outerHeight(true);
                });

                columnHeights.push(columnHeight);

                if (columnHeight > dashboardHeight) {
                    dashboardHeight = columnHeight;
                }
            });

            if (dashboardHeight < fullHeight - 20) {
                dashboardHeight = fullHeight - 20; // border-spacing
            }

            columns.each(function(index, value) {
                var column = $(value),
                    cardContainers = column.children('.js-card-container'),
                    difference = dashboardHeight > columnHeights[index] ? dashboardHeight - columnHeights[index] : 0,
                    actionlinks;

                cardContainers.each(function(index, value) {
                    var container = $(value),
                        card = container.children('.js-card'),
                        computedHeight = 0;

                    computedHeight = card.outerHeight(true) + difference/cardContainers.length;
                    if (cardContainers.length == 1) {
                        computedHeight += 10;
                    }

                    container.height(computedHeight);
                });
            });

            fixIE10();

            if (loading) {
                dashboard.addClass('is-animating');
                //dashboard.height(dashboardHeight + 10);

                setTimeout(function() {
                    dashboard.removeClass('is-animating');
                    //dashboard.height('');
                }, 1000);
            }

            dashboard.removeClass('reset');
            dashboard.removeClass('loading');
            calculating = false;
            loading = false;
        }

        if (!APP.mobileView) {
            update();
        }
        else {
            fixIE10();
            dashboard.removeClass('loading');
        }

        win.on("resize fontsLoaded", function() {
            if (!APP.mobileView) {
                new Debouncer(update).handleEvent();
            }
            else {
                fixIE10();
            }
        });
    }


    function buttonHover() {
        if (APP.touch) return;

        var buttons = $('.js-actionbutton', dashboard);

        buttons.each(function(index, value) {
            var button = $(value),
                decoration = new SVGAnimator($('.js-actionbutton-decoration', button)[0], {
                    speedIn : 200,
                    speedOut : 200,
                    easingIn: mina.easeinout,
                    easingOut: mina.easeinout
                });

            button.hover(function() {
                decoration.show();
            },
            function() {
                decoration.hide();
            });
        });
    }

    function flipCards() {
        var cards = $('.js-flipcard', dashboard);

        cards.each(function() {
            var card = $(this),
                front = card.children('.js-flipcard-front'),
                button = card.find('.js-flipbutton').eq(0),
                container = card.closest('.js-card-container');

            front.add(button).on('click', function(e) {
                e.preventDefault();

                if (!card.data('is-flipped')) {
                    //if (!card.data('is-popping')) {
                        cards.not(card).removeClass('is-flipped').data('is-flipped', false);
                        card.addClass('is-flipped').data('is-flipped', true);
                    //}
                }
                else {
                    //if (!card.data('is-popping')) {
                        card.removeClass('is-flipped');
                        card.data('is-flipped', false);
                    //}
                }
            });

            if (!bowser.msie) {
                container.mouseenter(function() {
                    if (!APP.touch && !APP.mobileView && !card.data('is-flipped') && !card.data('is-popping')) {
                        card.data('is-popping', true);

                        card.transition({
                            transform: 'rotateY(-15deg)',
                            duration: 150,
                            easing: 'ease',
                            complete: function() {
                                card.transition({
                                    transform: 'rotateY(0deg)',
                                    duration: 150,
                                    easing: 'ease',
                                    complete: function() {
                                        card.data('is-popping', false);
                                    }
                                });
                            }
                        });
                    }
                });
            }

        });
    }


    // Pages AJAX load
    function loadPages() {
        var links = $('.js-pagelink'),
            pageContainer = $('#page-container'),
            languageSwitchers = $('.js-language-switch').find('a'),
            originalTitle = $('title').eq(0).html();

        if (links.length && pageContainer.length) {
            var currentPage = window.location.href,
                smoothState = pageContainer.smoothState({
                    debug: true,
                    anchors: '.js-pagelink',
                    forms: null,
                    prefetch: true,
                    //prefetchOn: 'preload',
                    repeatDelay: 1000,
                    cacheLength: 50,
                    scroll : false,
                    onStart: {
                        duration: 0,
                        render: function (container, url) {
                            if (APP.mobileView) {
                                win.data('dashboardScrollPosition', win.data('scrollPosition'));
                            }

                            if (url && smoothState.cache[url].status != 'loaded') {
                                // Page is not cached, show the preloader
                                dashboard.append('<div class="page-loader js-page-loader"><div class="loader"></div></div>');
                            }
                        }
                    },
                    onReady: {
                        duration: 0,
                        render: function (container, newContent, url) {
                            var placePage = function() {
                                // Drop the page in place
                                APP.Elements.wrapper.addClass('page-active').removeClass('page-animating-in');
                                container.css('transform', 'none');

                                // Init the "after animation" page JS
                                APP.MODULES.page.initAfterDashboardAnimation();

                                // Update the language switchers
                                languageSwitchers.each(function(index, value) {
                                    var languageSwitcher = $(value),
                                        href = null;

                                    if (index === 0) {
                                        href = '/' + url.split("/").pop();
                                    }
                                    else {
                                        href = '/' + languageSwitcher.attr('href').split("/")[1] + '/' + url.split("/").pop();
                                    }

                                    languageSwitcher.attr('href', href);
                                });

                                // Let GA know
                                if (url) {
                                    ga('set', 'page', '/' + url);
                                    ga('send', 'pageview');
                                }
                            };

                            // Emit page load event
                            win.trigger('pageload');

                            // Inject the new content
                            container.html(newContent);

                            // Scroll to top
                            scrollPageTo(0);

                            // Show the page
                            APP.Elements.wrapper.addClass('page-visible');

                            // Remove the loader
                            $('.js-page-loader').remove();

                            // Start the animation
                            if (!APP.mobileView) {
                                APP.Elements.wrapper.addClass('page-animating-in');

                                container.css('transform', 'translateY(100%)');
                                container.transition({
                                    transform: 'translateY(0)',
                                    duration: 350,
                                    easing: 'ease',
                                    complete: function() {
                                        placePage();
                                    }
                                });

                                dashboard.css('transform', 'translateY(0)');
                                dashboard.transition({
                                    transform: 'translateY(50%)',
                                    duration: 350,
                                    easing: 'ease',
                                    complete: function() {

                                    }
                                });
                            }
                            else {
                                placePage();
                            }

                            // Init the page JS
                            win.data('scrollPosition', win.scrollTop());
                            APP.MODULES.page.init();
                        }
                    },
                    onAfter: function(container, newContent, url) {

                    }
                }).data('smoothState');



            APP.Elements.body.on('click', '.js-close-page', function(e) {
                e.preventDefault();

                var removePage = function() {
                    APP.Elements.wrapper.removeClass('page-animating-out').removeClass('page-visible');

                    pageContainer.css('transform', 'none');
                    dashboard.css('transform', 'none');

                    if (APP.mobileView) {
                        scrollPageTo(win.data('dashboardScrollPosition'));
                    }

                    pageContainer.empty();

                    ga('send', 'pageview', '/');
                };

                //win.trigger('resize');

                // Remove leftover lightboxes
                $('.fancybox-overlay').remove();
                APP.Elements.body.css('overflow-y','');
                APP.Elements.html.removeClass('fancybox-margin fancybox-lock');

                APP.Elements.wrapper.removeClass('page-active');

                // Update the title
                $('title').eq(0).html(originalTitle);

                if (!APP.mobileView) {
                    APP.Elements.wrapper.removeClass('page-animating-in').addClass('page-animating-out');

                    pageContainer.css('transform', 'translateY(0)');
                    pageContainer.transition({
                        transform: 'translateY(100%)',
                        duration: 350,
                        easing: 'ease',
                        complete: function() {
                            removePage();
                        }
                    });

                    dashboard.transition({
                        transform: 'translateY(0)',
                        duration: 350,
                        easing: 'ease',
                        complete: function() {
                            dashboard.css('transform', 'none');
                        }
                    });
                }
                else {
                    removePage();
                }

                languageSwitchers.each(function(index, value) {
                    var languageSwitcher = $(value),
                        href = null;

                    if (index === 0) {
                        href = '/';
                    }
                    else {
                        href = '/' + languageSwitcher.attr('href').split("/")[1] + '/';
                    }

                    languageSwitcher.attr('href', href);
                });

                window.history.pushState(null, null, APP.Elements.html.data('root'));
            });


            window.onpopstate = function(e) {
                var hash = location.hash;

                if (hash === '') {
                    e.preventDefault();
                    // Back/forward button was pressed
                    $('.js-close-page').eq(0).click();
                }
            };

            // if (!APP.touch) {
            //     if (!APP.isProduction) console.group('Preloading pages:');
            //     //links.trigger('preload');
            //     if (!APP.isProduction) console.groupEnd();
            // }
        }
    }


    function donutSVG() {
        $('.js-donut').each(function() {
            var donut = $(this),
                svg = donut.children('svg'),
                duration = svg.data('duration') ? svg.data('duration') : 2000,
                donutPercentage = svg.data('percentage'),
                canvasSize = svg.data('width'),
                centre = canvasSize/2,
                radius = canvasSize*0.8/2,
                s = Snap(svg[0]),
                path = "",
                arc = s.path(path),
                startY = centre-radius,
                percentageIndicator = donut.find('.js-donut-percent');

            var fullCircle = s.circle(centre, centre, radius);

            fullCircle.attr({
                stroke: "rgba(255,255,255,0.5)",
                fill: "none",
                strokeWidth: 5
            });

            function run(percent) {
                var endpoint = percent/100*360;

                Snap.animate(0, endpoint, function (val) {
                    arc.remove();

                    var d = val,
                        dr = d-90,
                        radians = Math.PI*(dr)/180,
                        endx = centre + radius*Math.cos(radians),
                        endy = centre + radius * Math.sin(radians),
                        largeArc = d>180 ? 1 : 0;
                        path = "M"+centre+","+startY+" A"+radius+","+radius+" 0 "+largeArc+",1 "+endx+","+endy;

                    arc = s.path(path);
                    arc.attr({
                      stroke: '#fff',
                      fill: 'none',
                      strokeWidth: 5
                    });
                    percentageIndicator.html(Math.round(val/360*100));
                }, duration, mina.easeinout);
            }

            run(donutPercentage);
        });
    }

    function init() {
        APP.MODULES.dashboard.loaded = true;

        APP.MODULES.page.polyfillSVG();

        updateDashboardHeight();
        buttonHover();

        donutSVG();
        flipCards();
        loadPages();

        APP.MODULES.page.counters(dashboard);
    }

    return {
        init: init
    };
}();

APP.MODULES.dashboard.loaded = false;
